import React from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { PensionDiscountInfo } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatCurrency, formatPercentage } from "../../../../utils/namesFormater";

interface PensionDiscountInfoCardProps {
  discountInfo: PensionDiscountInfo[];
}

const formatPeriod = (period?: string): string => {
  if (!period || period.length < 6) return "-";
  const year = period.slice(0, 4);
  const month = period.slice(4, 6);
  return `${month}/${year}`;
};

export const PensionDiscountInfoCard: React.FC<PensionDiscountInfoCardProps> = ({ discountInfo }) => {
  if (!discountInfo || discountInfo.length === 0) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        מידע הנחות
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell><strong>תקופה התחלה</strong></TableCell>
              <TableCell><strong>תקופה סיום</strong></TableCell>
              <TableCell align="right"><strong>אחוז הנחה</strong></TableCell>
              <TableCell align="right"><strong>סכום הנחה</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {discountInfo.map((discount, index) => (
              <TableRow key={index} hover>
                <TableCell>{formatPeriod(discount.start_period)}</TableCell>
                <TableCell>{formatPeriod(discount.end_period)}</TableCell>
                <TableCell align="right">
                  {discount.discount_percentage !== undefined && discount.discount_percentage !== 0
                    ? formatPercentage(discount.discount_percentage)
                    : "-"}
                </TableCell>
                <TableCell align="right">
                  {discount.discount_amount !== undefined && discount.discount_amount !== 0
                    ? formatCurrency(discount.discount_amount)
                    : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
